module.exports = __webpack_public_path__ + "img/trophy-solid.3fa87381.svg";